import "./GridRow15.css";
const GridRow15 = () => {
  return (
    <>
      <div id="GridBox16Id" className="GridBox15">
        <div className="Fifteen1">
          <h4>Join IKEA Family</h4>
          <p>
            Enjoy guaranteed discounts, special previews, food offers and much
            more. It’s free and only takes a minute to join.
          </p>{" "}
          <a>Join us</a>
          <h4>IKEA for Business</h4>{" "}
          <p>
            Our business & design experts help you with flexible, affordable and
            sustainable solutions. Create a better life at work with us.
          </p>{" "}
          <a>Join now</a>
        </div>
        <div className="Fifteen2">
          <h4>IKEA Family</h4>
          <a>Log in</a>
          <a>Join IKEA Family</a>
          <a>Member offers</a>
          <a>Workshops & Events</a>
        </div>
        <div className="Fifteen3">
          <h4>Services</h4>
          <a>Design your room</a>
          <a> Delivery Service</a>
          <a> Installation Service</a>
          <a>Assembly Service</a>
          <a> Kitchen Planning</a>
          <a> Measuring Service </a>
          <a>Customer Service</a>
          <a> Recycle Program </a>
          <a>Track Your Order</a>
        </div>
        <div className="Fifteen4">
          <h4>Help</h4>
          <a>How to shop</a>
          <a>Return policy</a>
          <a>Prices and price tags</a>
          <a>Contact us</a>
          <a>FAQ's</a>
          <a>Planners</a>
          <a>Size guide - Beds & mattresses</a>
          <a>Buying guides</a>
          <a>Gift Card</a>
          <a>Feedback</a>
        </div>
        <div className="Fifteen5">
          <h4>About IKEA</h4>
          <a>This is IKEA</a>
          <a>Working at IKEA</a>
          <a>Newsroom</a>
          <a>Sustainability</a>
          <a>IKEA Stores</a>
          <a>IKEA Restaurant</a>
          <a>IKEA for Business</a>
        </div>
      </div>
    </>
  );
};
export default GridRow15;
